<template>
  <search-custom-dropdown
    v-model="searchInput.priceBtn.state"
    :search-input-text="searchInput.priceBtn.text"
    :is-filled="searchInput.priceBtn.text === 'Any Price' ? false : true"
    :width="100"
  >
    <template v-slot:drop-content>
      <v-layout wrap class="px-3 pt-3">
        <v-flex
          v-for="(item, index) in priceParams"
          :key="item.name"
          xs6
          class="pa-1"
        >
          <input
            v-model="item.value"
            type="text"
            :placeholder="
              searchObject.searchType === 'rent'
                ? item.title
                : item.title.substr(0, 3)"
            class="search-price-input"
            @keyup.enter="updatePrice(index, $event.target.value)"
            @input="updatePrice(index, $event.target.value)"
          >
          <v-divider class="my-2" />
          <div
            xs6
            class="price-selector"
            :class="{
              selected: priceParams[index].value === '',
              result: searchObject.searchResult
            }"
            :style="{
              'padding-left': searchObject.searchResult ? '0.5rem' : '2rem'
            }"
            @click.stop="priceClicked(item, '')"
          >
            {{ `No ${item.title.substr(0, 3)}` }}
          </div>
          <div
            v-for="(priceValue, i) in modifiedPriceValues[index]"
            :key="`${item.name}_${i}`"
            xs6
            class="price-selector"
            :class="{
              selected: priceParams[index].value === priceValue,
              result: searchObject.searchResult
            }"
            :style="{
              'padding-left': searchObject.searchResult ? '0.5rem' : '2rem'
            }"
            @click.stop="priceClicked(item, priceValue)"
          >
            $ {{ commaSeparated(priceValue) }}
          </div>
        </v-flex>
      </v-layout>
    </template>
  </search-custom-dropdown>
</template>

<script>
import searchLayoutHandler from '../../mixins/searchLayoutHandler'
import { isEmpty } from '../../../utils/generalUtils'

export default {
  mixins: [searchLayoutHandler],

  props: {
    priceOptions: {
      type: Array,
      required: true
    },
    maxPrice: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      priceParams: [
        { name: 'minValue', value: '', title: 'Min Rent' },
        { name: 'maxValue', value: '', title: 'Max Rent' }
      ]
    }
  },

  computed: {
    modifiedPriceValues() {
      const minArr = this.priceOptions
      if (this.priceParams[0].value) {
        const minPriceIndex = minArr.indexOf(this.priceParams[0].value)
        const maxArr = minArr.filter((price, index) => index > minPriceIndex)
        if (maxArr) return [minArr, maxArr]
      }
      return [minArr, minArr]
    }
  },

  watch: {
    selectedPrice: {
      handler: function(newValue) {
        if (!isEmpty(newValue) && this.searchObject.searchResult) {
          this.priceParams[0].value =
            newValue.minPrice === '0' ? '' : newValue.minPrice
          this.priceParams[1].value =
            newValue.maxPrice === '10000000' ? '' : newValue.maxPrice
        }
      }
    }
  },

  methods: {
    commaSeparated(val) {
      return (val || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    getPriceInputValue(item) {
      if (item.name === 'minValue') {
        return item.value
      } else {
        return item.value >= this.maxPrice ? '' : item.value
      }
    },

    updatePrice(index, value) {
      if (!value.match(/^\d+$/)) value = value.slice(0, -1)
      this.priceParams[index].value = value
      this.radioClicked()
    },

    priceClicked(item, event) {
      if (item.name === 'minValue') {
        this.priceParams[0].value = event
        this.priceParams[1].value = ''
      } else if (item.name === 'maxValue') {
        this.priceParams[1].value = event
      }

      const priceRange = `${this.priceParams[0].value || '0'}-${this
        .priceParams[1].value || this.maxPrice}`
      this.updatePriceRange(priceRange, this.maxPrice)
    }
  }
}
</script>

<style lang="sass">
.radio-select-price
  max-height: 30rem
  overflow-y: auto
  label
    font-size: 1.2rem
</style>

<style lang="sass" scoped>
.search-price-input
  border-radius: 0.5rem
  padding: 0.7rem
  border: 1px solid $hwayzBlack
  font-size: 1.4rem
  max-width: 10rem

.price-selector
  cursor: pointer
  border: 0.1rem solid transparent
  font-size: 1.4rem
  text-align: left !important
  padding-top: 0.2rem
  padding-bottom: 0.2rem
  // min-width:
  &.selected
    // border: 0.1rem solid $hwayzBlack
    background-color: $hwayzLightGray
    &.result
      border: 0.1rem solid $hwayzKellyGreen
      color: $hwayzWhite
      background-color: $hwayzKellyGreen

/* Image Scrollbar custom style */
.radio-select-price::-webkit-scrollbar-track
  background-color: $hwayzLightGray
  border: solid 1px $hwayzLightGray

.radio-select-price::-webkit-scrollbar
  width: 6px
  background-color: $hwayzLightGray

.radio-select-price::-webkit-scrollbar-thumb
  background-color: $hwayzShadow
  border-radius: 3px
</style>
